import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Section, SectionHeading, Reveal } from '../shared/Section';
const bonuses = [{
  tag: 'Bono 1',
  title: 'Guía de Estiramientos Completos por Tiempo',
  text: 'Elegí tu tiempo disponible y seguí una secuencia completa de estiramientos para sumar movilidad incluso en los días más ocupados.'
}, {
  tag: 'Bono 2',
  title: 'Rutina Anti-tensión para Cuello y Trapecios',
  text: 'Una rutina práctica y suave para soltar la carga acumulada en cuello, hombros y trapecios después de horas frente a la pantalla.'
}, {
  tag: 'Bono 3',
  title: 'Checklist de Progreso Semana a Semana',
  text: 'Registrá tus prácticas, identificá cambios reales y mantené la motivación con una guía clara de avance semanal.'
}];
export function Bonuses() {
  return <Section id="bonos" bg="bg-white" data-id="element-14" data-mp="kvl4r4zuua07">
      <Reveal data-id="element-15" data-mp="fux3lqhwwcs9">
        <SectionHeading eyebrow="🎁 De regalo" title="3 Bonos incluidos con tu inscripción" subtitle="Además de los 6 módulos, recibís estos regalos que potencian todo lo que aprendés." data-id="element-16" data-mp="fv6xvq9zp63r" />
      </Reveal>

      <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-17" data-mp="1js80xdnhgcwz">
        {bonuses.map((b, i) => <Reveal key={b.tag} index={i} data-id="element-18" data-mp="15s6z9vze91gg" data-mpi={i}>
            <div className="flex h-full flex-col rounded-2xl border-2 border-dashed border-clay-400/40 bg-clay-400/[0.06] p-6" data-id="element-19" data-mp="15vba3c7d6vg3">
              <div className="flex items-center gap-2" data-id="element-20" data-mp="w2ng0p7rr5l2">
                <GiftIcon className="h-5 w-5 text-clay-500" data-id="element-21" data-mp="w12nf550lwpu" />
                <span className="text-xs font-bold uppercase tracking-wider text-clay-600" data-id="element-22" data-mp="10uxc6mzh91vs">
                  {b.tag}
                </span>
              </div>
              <h3 className="mt-3 font-display text-lg font-semibold text-forest-800" data-id="element-23" data-mp="r42iixjwj00b">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-forest-700/70" data-id="element-24" data-mp="d4b9zcc5mbtp">{b.text}</p>
            </div>
          </Reveal>)}
      </div>
    </Section>;
}